angular.module('impactx.deliverynote').controller('DeliveryNoteReplacementChoiceCtrl', [
    '$mdDialog',
    'dataGen',
    '$config',
    'NewWindowService',
    '$window',
    'DeliveryNoteOCIService',
    '$location',
    '$routeParams',
    DeliveryNoteReplacementChoiceCtrl]);

function DeliveryNoteReplacementChoiceCtrl($mdDialog, dataGen, $config, NewWindowService, $window, DeliveryNoteOCIService, $location, $routeParams) {
    var self = this;
    self.wizardIndex = 0;
    self.catalogChoice = 0;
    self.data = {
        choice: 0,
        freeform: {
            articleNumber: '',
            articleName: '',
            articleNumberRequired: self.articleNumberRequired,
            deliveredAmount: self.openAmount,
            unit: {
                id: undefined,
                value: undefined
            }
        }
    };

    self.cancel = function () {
        $mdDialog.cancel();
    };

    self.addFreeform = function () {
        var freeformProduct = generateFreeformDNI();
        $mdDialog.hide({ociJump: false, freeformProduct: freeformProduct});
    };

    self.continue = function () {
        $mdDialog.hide();
    };

    self.continueOCI = function () {
        self.wizardIndex = 1;
        if (self.dialogData.dnh.externalCatalogs.length === 1) {
            self.catalogChoice = self.dialogData.dnh.externalCatalogs[0].value;
            self.jumpOCI();
        }
    }

    self.backOCI = function () {
        self.wizardIndex = 0;
    }

    self.jumpOCI = function () {
        var catId = self.catalogChoice;
        var item = "";
        var currentPath = $location.path();

        if ($routeParams.messages !== null && $routeParams.messages !== undefined) {
            currentPath = currentPath.substring(0, currentPath.lastIndexOf("/"))
        }
        if ($routeParams.warnings !== null && $routeParams.warnings !== undefined) {
            currentPath = currentPath.substring(0, currentPath.lastIndexOf("/"))
        }
        if ($routeParams.errors !== null && $routeParams.errors !== undefined) {
            currentPath = currentPath.substring(0, currentPath.lastIndexOf("/"))
        }

        dataGen.postAsForm({}, {data: self.dialogData.dnh, trns: self.trns}, "/deliverynote/storedto").then(function () {
            if (NewWindowService.check()) {
                DeliveryNoteOCIService.storeURL($config.baseURL + "/oci/ocipage.jsp?CAT.Id=" + catId +
                    "&impactX=true&delnoteReplace=" + encodeURI(currentPath) + "&delnoteItem=" + item);
                $mdDialog.hide({ociJump: true});
            }
        });

    };

    function generateFreeformDNI() {
        var freeformData = self.data.freeform;

        return {
            bundlePosition: '',
            isFreeform: true,
            replacedAmount: self.openAmount,
            deliveredAmount: {
                value: freeformData.deliveredAmount,
                unit: freeformData.unit.unitSingular,
                unitSingular: freeformData.unit.unitSingular,
                unitPlural: freeformData.unit.unitPlural
            },
            finalDelivery: false,
            openAmount: 0,
            orderedAmount: 0,
            poiIds: [],
            productName: {
                value: freeformData.articleName,
                readOnly: false
            },
            proId: 0,
            priIds: [],
            supplierNo: {
                value: freeformData.articleNumber,
                readOnly: false,
                showMust: freeformData.articleNumberRequired
            },
            canDelete: true,
            control: freeformData.control
        };
    }

    this.initFreeformControls = function () {
        if(!self.data.freeform.control) {
            dataGen.getData({}, {dniId: 0}, "/deliverynote/item/controls").then(function (data) {
                self.data.freeform.control = data.data;
            });
        }
    }

    this.checkRequireCtrl = function (type) {
        let ctrlElem = self.data.freeform.control[type];
        if (ctrlElem) {
            return ctrlElem.showMust;
        }
        return false;
    };
}